export const BUTTON_TYPES = {
  ADD_TO_CART: 'addToCart',
  BUY_NOW: 'buyNow',
  UNAVAILABLE: 'unavailable',
  CHECK_OUT: 'checkOut',
}

export const BUTTON_TYPES_OPTIONS = {
  [BUTTON_TYPES.ADD_TO_CART]: {
    icon: 'icon-add-shopping-cart',
    iconColor: '#3DA967',
    label: 'domesticSearchPreview.ADD_TO_CART',
    labelColor: '',
    buttonBackgroundColor: '#fff',
    buttonStyle: {
      border: '1px solid #d1d1d1',
    },
  },
  [BUTTON_TYPES.BUY_NOW]: {
    icon: 'icon-money',
    iconColor: '#fff',
    label: 'domesticSearchPreview.BUY_NOW',
    labelColor: '#fff',
    buttonBackgroundColor: '#3DA967',
    buttonStyle: {},
  },
  [BUTTON_TYPES.UNAVAILABLE]: {
    icon: 'icon-unavailable',
    iconColor: '#9C9C9C',
    label: 'domesticSearchPreview.UNAVAILABLE',
    labelColor: '#9C9C9C',
    buttonBackgroundColor: '#D5D5D5',
    buttonStyle: {},
  },
  [BUTTON_TYPES.CHECK_OUT]: {
    icon: 'icon-checkout',
    iconColor: '#fff',
    label: 'domesticSearchPreview.BUY_NOW',
    labelColor: '#fff',
    buttonBackgroundColor: '#3DA967',
    buttonStyle: {},
  },
}
